<template>
  <div v-if="isLoading" class="p-4 text-center">
    <span class="loading loading-spinner loading-lg text-base-content/60"></span>
  </div>
  <div v-else class="h-full flex flex-col">
    <div class="flex-1 px-4 pt-20">
      <div class="text-center text-sm text-base-content/60">Informacija ruošiama</div>
    </div>
  </div>
</template>

<script setup>
import { onMounted, ref } from "vue";

import { useAuthStore } from "@/stores/auth";

const authStore = useAuthStore();
const isLoading = ref(true);

onMounted(async () => {
  try {
    isLoading.value = true;
    await authStore.fetchUser();
  } catch (error) {
    console.error("Failed to fetch user:", error);
  } finally {
    isLoading.value = false;
  }
});
</script>
